import bemBlock from "@gik/core/utils/bemBlock";
import type { UI } from "@gik/ui";
import classnames from "classnames";
import type React from "react";
import type { CSSProperties } from "react";

export type ILayoutAsideProps = React.HTMLAttributes<HTMLDivElement> &
	UI.ComponentProps & {
		asideWidth?: string;
		gutter?: string;
		breakpoint?: string;
		elementQueries?: boolean;
	};

export function LayoutAside({
	children,
	asideWidth,
	gutter,
	breakpoint,
	elementQueries,
	className,
	id,
}: ILayoutAsideProps) {
	const bem = bemBlock(elementQueries ? "layout-aside-eq" : "layout-aside");
	const blockClasses = classnames([bem(), className || ""]);
	const otherProps: Partial<ILayoutAsideProps> = {};
	if (elementQueries) {
		otherProps.style = {
			"--aside-width": asideWidth,
			"--gutter": gutter,
			"--breakpoint": breakpoint,
		} as CSSProperties;
	} else {
		otherProps.style = {
			"--aside-width": asideWidth,
			"--gutter": gutter,
		} as CSSProperties;
	}
	return (
		<div className={blockClasses} id={id} {...otherProps}>
			{children}
		</div>
	);
}
